'use client'

import React from 'react'
import { useRef } from "react";
import { useDraggable } from "react-use-draggable-scroll";
import UsefulMatCard from './UsefulMatCard'
import { MaterialsItem } from '@/redux/services/materialsApi';

interface UsefulSliderProps {
    list: MaterialsItem[],
    scroll: number
}

const UsefulMatSlider: React.FC<UsefulSliderProps> = ({ list, scroll }) => {
    const ref =
        useRef<HTMLDivElement>() as React.MutableRefObject<HTMLInputElement>;
    const { events } = useDraggable(ref);

    React.useEffect(() => {
        if (ref.current) {
            ref.current.scrollLeft = scroll;
        }
    }, [list]);

    return (
        <div
            className='useful-materials__carousel-slider'
            {...events}
            ref={ref}
        >
            {list && list?.map((slide) => (
                <UsefulMatCard key={slide.id} item={slide} />
            ))}
        </div>
    )
}

export default UsefulMatSlider
